export const adicionarItemLista = (lista: string[], setLista: (items: string[]) => void, valor: string) => {
  const valorTrimmed = valor.trim();
  if (valorTrimmed) {
    // Verificar se o item já existe na lista (case-insensitive)
    const jaExiste = lista.some(item => item.toLowerCase() === valorTrimmed.toLowerCase());
    if (!jaExiste) {
      setLista([...lista, valorTrimmed]);
    } else {
      // Opcional: mostrar um aviso ao usuário
      alert('Este perigo já foi adicionado anteriormente.');
    }
  }
};

// Função para adicionar múltiplos itens à lista (sem mostrar alertas para cada duplicata)
export const adicionarMultiplosItensLista = (lista: string[], setLista: (items: string[]) => void, valores: string[]) => {
  const novosItens: string[] = [];
  valores.forEach(valor => {
    const valorTrimmed = valor.trim();
    if (valorTrimmed) {
      // Verificar se o item já existe na lista (case-insensitive)
      const jaExiste = lista.some(item => item.toLowerCase() === valorTrimmed.toLowerCase()) ||
                      novosItens.some(item => item.toLowerCase() === valorTrimmed.toLowerCase());
      if (!jaExiste) {
        novosItens.push(valorTrimmed);
      }
    }
  });
  
  if (novosItens.length > 0) {
    setLista([...lista, ...novosItens]);
  }
};

export const removerItemLista = (lista: string[], setLista: (items: string[]) => void, index: number) => {
  setLista(lista.filter((_, i) => i !== index));
};

